<template>
    <div>
        <div class="w_1200 clearfix2 box_mh20">
            <div class="fl black6_text box_pt8">今天是 <span v-text="now"></span></div>
            <div class="fr">
                <Search/>
            </div>
        </div>
        <!--end一行-->

        <div class="clearfix2 box_mt20 w_1200">

            <table class="list_table blue_link box_c hover_table_bj box_mt20">
                <thead>
                <tr class="black9_text">
                    <th></th>
                    <th width="110px;">资源类型</th>
                    <th width="100px;">资源编号</th>
                    <th width="100px;">公告号</th>
                    <th width="80px;">区域</th>
                    <th style="min-width: 100px;">项目名称</th>
                    <th width="100px;">公告发布时间</th>
                    <th width="100px;">状态</th>
                    <th width="50px;">操作</th>
                </tr>
                </thead>
                <tbody v-if="dataList !== undefined && dataList !== null && dataList.length>0">
                <tr v-for="(data,index) in dataList" :key="index">
                    <td><span class="num_box blue_bj" v-text="index+1"></span></td>
                    <td v-text="data.zylxText"></td>
                    <td v-text="data.zybh"></td>
                    <td><span class="td_a hide2" v-text="data.ggh"></span></td>
                    <td v-text="data.qyText"></td>
                    <td><span class="td_a hide2" v-text="data.xmmc" :title="data.xmmc" style="width: 100%"></span></td>
                    <td v-text="data.ggfbsj"></td>
                    <td v-text="data.gtmhzyztText"></td>
                    <td><a :href="detailUrlByZyztAndId(data.zyztCode, data.id)">查看</a></td>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                    <td colspan="10" style="color: #999;display: none">暂无记录</td>
                </tr>
                </tbody>
            </table>
        </div>
        <!--end一行-->

    </div>
</template>

<script>
    import {api} from "@/core/api"
    import {getNow} from '@/core/common'
    import {detailUrl} from '@/core/getDetailUrl'
    import ggzw from '@/components/Ggzw'
    import Search from "@/components/Search";

    export default {
        name: "Home",
        components: {Search},
        data() {
            return {
                detailUrl: detailUrl,
                now: null,
                dataList: []
            }
        },
        mounted() {
            this.now = getNow();
            this.getAllData();
        },
        methods: {
            detailUrlByZyztAndId(zyztCode, id) {
                if (zyztCode === "01") {
                    return detailUrl.zzgg(id);
                } else if (zyztCode === "02") {
                    return detailUrl.zzgp(id);
                } else if (zyztCode === "03" || zyztCode === "04" || zyztCode === "06") {
                    return detailUrl.jggs(id);
                }
            },
            getAllData() {
                api.getSyzyList({page: 1, rows: 20}).then(response => {
                    this.dataList = response.data;
                });
            },
            read(content) {
                this.$layer.iframe({
                    content: {
                        content: ggzw, //传递的组件对象
                        parent: this,//当前的vue对象
                        data: {
                            content: content
                        }
                    },
                    area: ['1100px', '500px'],
                    title: '公告',
                    scrollbar: false
                });
            }
        }
    }
</script>

<style scoped>

</style>
